import client from "@/lib/api";
import { useNavigate } from "@/lib/useNav";
import { formatMoney } from "@/lib/format";
import { STAT_METRICS } from "@/lib/dashboardBlocks";
import { useBlockData } from "@/components/dashboard/useBlockData";

// Share one request per scope across all report tiles on the page.
const cache = {};
const fetchStats = (scope) => {
  const k = scope || "mine";
  const hit = cache[k];
  if (hit && Date.now() - hit.at < 3000) return hit.p;
  const p = client.get("/dashboard/stats", { params: { scope: k } }).then((r) => r.data);
  cache[k] = { at: Date.now(), p };
  return p;
};

export function StatBlock({ block, editing }) {
  const s = block.settings || {};
  const navigate = useNavigate();
  const m = STAT_METRICS[s.metric] || STAT_METRICS.open_tasks;
  const [data] = useBlockData(() => fetchStats(s.scope), [s.scope], 30000);
  const v = data?.[s.metric];
  return (
    <button disabled={editing} onClick={() => navigate(s.scope === "team" && m.teamHref ? m.teamHref : m.href)} className="block w-full text-left" data-testid={`block-${block.id}-stat`}>
      <p className="font-heading text-3xl font-bold text-slate-900" data-testid={`block-${block.id}-stat-value`}>
        {v == null ? "—" : m.money ? formatMoney(v) : v}
      </p>
      <p className="mt-0.5 text-xs font-medium text-slate-400">{block.title && block.title.toLowerCase() !== m.label.toLowerCase() ? `${m.label} · ` : ""}{s.scope === "team" ? "Everyone" : "Mine"}</p>
    </button>
  );
}
